export enum AppThemeConstants {
  MODE = 'light',
  PRIMARY_COLOR = '#1D4F91',
  SECONDARY_COLOR = 'gray',
  BLACK = '#000',
  WHITE = '#FFF',
  TRANSPARENT = '#d6e3f429',
}
